import { AxiosResponse } from 'axios'
import { InsuranceCaseType, PostCaseReportRespType } from '../../models'
import fetch from '../fetch'

/**
 * POST /case-report
 *
 * postCaseReport
 * - sends CaseReportParams data to the server via POST /case-report
 */
export function postCaseReport(
  caseReportParams: InsuranceCaseType
): Promise<AxiosResponse<PostCaseReportRespType>> {
  return fetch({
    method: 'POST',
    path: `api/v1/case-report?message=true`,
    data: caseReportParams,
  })
}
